import * as z from 'zod';

export type TreeifyError<T> = ReturnType<typeof z.treeifyError<T>>;

export function errorsFromSafeResult<T>(result: z.ZodSafeParseResult<T>): TreeifyError<T> {
  if (result.success) {
    return { errors: [] } as unknown as TreeifyError<T>;
  }

  return z.treeifyError(result.error);
}

export const nonLiteralString = () => z.string();
